import React from 'react'

import { VideoTrack } from '../../../../MediaTracks/components/VideoTrack/VideoTrack'
import { useParticipant } from '../../../../webrtc/webRTCRoom'
import { posToStyle, useFeedPosition } from '../../../layouts'

interface FloorCameraFeedProps {
  id: number
}

const FloorScreenFeed = ({ id }: FloorCameraFeedProps) => {
  const participant = useParticipant(id)
  const position = useFeedPosition('screen', id)

  if (!participant?.tracks.screen) return null

  return (
    <div className="participant-screen-track" style={posToStyle(position)}>
      <VideoTrack track={participant.tracks.screen} objectFit="contain" />
    </div>
  )
}

export { FloorScreenFeed }
